import { z } from "zod";
import { identityBlock, futureDateIso } from "./common.js";
export const motorCoverType = z.enum(["COMPREHENSIVE", "THIRD_PARTY"]);
export const motorExtensions = z.object({
    excessProtector: z.boolean().default(false),
    politicalViolenceAndTerrorism: z.boolean().default(false),
    aaRoadRescue: z.boolean().default(false),
    personalAccident: z.boolean().default(false),
    courtesyCar: z.boolean().default(false),
});
export const motorPayloadSchema = identityBlock.extend({
    make: z.string().min(1),
    model: z.string().min(1),
    coverType: motorCoverType,
    vehicleValueKes: z
        .number()
        .int()
        .positive()
        .optional()
        .describe("Required when coverType=COMPREHENSIVE"),
    registrationNumber: z
        .string()
        .min(3)
        .transform((s) => s.toUpperCase()),
    yearOfManufacture: z.number().int().min(1980).max(new Date().getFullYear()),
    extensions: motorExtensions,
    coverStartDate: futureDateIso,
});
